export function cookieText(lang: string): JSX.Element {
  switch (lang) {
    case 'cs':
      return csCookie();
    case 'sk':
      return skCookie();
    case 'uk':
      return ukCookie();
    case 'pl':
      return plCookie();
    case 'en':
    default:
      return enCookie();
  }
}

function csCookie() {
  return (
    <>
      <h2>Soubory cookie stránek (nezbytné soubory cookie)</h2>
      <p>
        Určité Cookies, které používáme, jsou nezbytné pro poskytování služeb Dramoxu. Pokud v nastavení cookies ve svém
        prohlížeči takové cookies zakážete, nebudete naše stránky a služby moci využívat. Následující tabulka uvádí
        cookies stránek, které používáme, a důvody jejich použití. Upozorňujeme, že cookies popsané v těchto zásadách
        jsou používány na všech platformách, na nichž jsou naše služby k dispozici.
      </p>
      <b>Funkční cookies</b>
      <ul>
        <li>Typ souboru: Trvalé</li>
        <li>Účel: funkčnost internetových stránek</li>
        <li>
          Funkce: Pomáhají váš počítač identifikovat, jestliže opětovně navštívíte naši internetovou stránku. Umožňují
          přizpůsobit naše internetové stránky vašim potřebám.
        </li>
        <li>Platnost: 1 rok</li>
      </ul>
      <h2>Cookies třetích stran (analytické cookies)</h2>
      <p>
        Níže uvedené cookies jsou nastaveny třetími stranami, nikoliv našimi stránkami. Tyto soubory cookie mohou být
        použity jen s Vaším předchozím souhlasem.
      </p>
      <b>
        Hotjar
        <br />
      </b>
      <ul>
        <li>Typ souboru: Trvalé</li>
        <li>Účel: Analýza/měření</li>
        <li>
          Funkce:&nbsp;Společnost Hotjar používá některé soubory cookie, aby mohla identifikovat návštěvníky, vyhodnotit
          vzorce jejich chování a analyzovat návštěvnost.
        </li>
        <li>Platnost: 1 rok</li>
      </ul>
      <b>
        <b>
          <b>
            Google&nbsp;Analytics
            <br />
          </b>
        </b>
      </b>
      <ul>
        <li>
          <span>
            Typ souboru:<span>&nbsp;</span>
          </span>
          <span>Trvalé</span>
        </li>
        <li>
          <span>
            Účel:<span>&nbsp;</span>
          </span>
          <span>Analýza/měření</span>
        </li>
        <li>
          <span>Funkce:&nbsp;</span>Společnost Google využívá soubory cookie pro získávání internetových statistik a
          sledování konverzního poměru.
        </li>
        <li>
          <span>Platnost: 2 roky</span>
        </li>
      </ul>
      <b>
        Google Tag Manager
        <br />
      </b>
      <ul>
        <li>
          <span>Typ souboru: </span>
          <span>Trvalé</span>
        </li>
        <li>
          <span>Účel: </span>
          <span>Analýza/měření</span>
        </li>
        <li>
          <span>Funkce:&nbsp;</span>Společnost Google využívá soubory cookie pro získávání internetových statistik a
          sledování konverzního poměru.
        </li>
        <li>
          <span>Platnost: 1-20 let</span>
        </li>
      </ul>
      <b>
        Netquest
        <br />
      </b>
      <ul>
        <li>
          <span>Typ souboru: </span>
          <span>Trvalé</span>
        </li>
        <li>
          <span>Účel: </span>
          <span>Analýza/měření</span>
        </li>
        <li>
          <span>Funkce:&nbsp;</span>Společnost Netquest využívá soubory cookie pro získání internetových statistik k
          analýze zpětné vazby a zpracování dotazníkových šetření.
        </li>
      </ul>
      <h2>Reklamní cookies</h2>
      <p>
        Následující tabulka uvádí cookies které používáme pro marketingové účely. I tyto cookies nastavuje třetí strana
        a nikoli my. Souhlas s jejich použitím můžete kdykoli vyloučit nastavením svého prohlížeče, jak je uvedeno dále.
        Blokace těchto souborů neovlivní fungování služby Dramox.
      </p>
      <b>
        Google Ads
        <br />
      </b>
      <ul>
        <li>Typ souboru: Trvalé</li>
        <li>Účel: Zobrazování / cílení reklam</li>
        <li>
          Funkce: Internetové stránky používají tyto soubory cookies pro měření efektivity svých on-line marketingových
          kampaní
        </li>
        <li>Platnost: 1 rok</li>
      </ul>
      <b>
        Facebook
        <br />
      </b>
      <ul>
        <li>Typ souboru: Trvalé</li>
        <li>Účel: Zobrazování / cílení reklam</li>
        <li>
          Funkce: Internetové stránky používají tyto soubory cookies pro měření efektivity svých on-line marketingových
          kampaní
        </li>
        <li>Platnost: 1 rok</li>
      </ul>
      <b>
        Sklik
        <br />
      </b>
      <ul>
        <li>Typ souboru: Trvalé</li>
        <li>Účel: Zobrazování / cílení reklam</li>
        <li>
          Funkce: Internetové stránky používají tyto soubory cookies pro měření efektivity svých on-line marketingových
          kampaní
        </li>
        <li>Platnost: 1 rok</li>
      </ul>
      <b>
        Google Remarketing
        <br />
      </b>
      <ul>
        <li>Typ souboru: Trvalé</li>
        <li>Účel: Zobrazování / cílení reklam</li>
        <li>
          Funkce: Internetové stránky používají tyto soubory cookies pro měření efektivity svých on-line marketingových
          kampaní
        </li>
        <li>Platnost: 1 rok</li>
      </ul>
    </>
  );
}

function skCookie() {
  return (
    <>
      <h2>Súbory cookie stránok (nevyhnutné súbory cookie)</h2>
      <p>
        Určité Cookies, ktoré používame, sú nevyhnutné na poskytovanie služieb Dramoxu. Pokiaľ v nastavení cookies vo
        svojom prehliadači takéto cookies zakážete, nebudete naše stránky a služby môcť využívať. Nasledujúca tabuľka
        uvádza cookies internetových stránok, ktoré používame, a dôvody ich použitia. Upozorňujeme, že súbory cookie
        popísané v týchto zásadách sú používané na všetkých platformách, na ktorých sú naše služby k dispozícii.
      </p>
      <b>Funkčné cookies</b>
      <ul>
        <li>Typ súboru: Trvalé</li>
        <li>Účel: funkčnosť internetových stránek</li>
        <li>
          Funckia: Pomáhajú identifikovať váš počítač, ak znovu navštívite našu webovú lokalitu. Umožňujú nám
          prispôsobiť naše webové stránky vašim potrebám.
        </li>
        <li>Platnosť: 1 rok</li>
      </ul>
      <h2>Cookies tretích strán (analytické cookies)</h2>
      <p>
        Nižšie uvedené cookies sú nastavené tretími stranami, nie našimi stránkami. Tieto súbory cookie môžu byť použité
        iba s Vašim predchádzajúcim súhlasom.
      </p>
      <b>
        Hotjar
        <br />
      </b>
      <ul>
        <li>Typ súboru: Trvalé</li>
        <li>Účel: Analýza/meranie</li>
        <li>
          Funkcia:&nbsp;Hotjar používa určité súbory cookie na identifikáciu návštevníkov, vyhodnocovanie vzorcov
          správania sa návštevníkov a analýzu návštevnosti.
        </li>
        <li>Platnosť: 1 rok</li>
      </ul>
      <b>
        <b>
          <b>
            Google&nbsp;Analytics
            <br />
          </b>
        </b>
      </b>
      <ul>
        <li>
          <span>
            Typ súboru:<span>&nbsp;</span>
          </span>
          <span>Trvalé</span>
        </li>
        <li>
          <span>
            Účel:<span>&nbsp;</span>
          </span>
          <span>Analýza/meranie</span>
        </li>
        <li>
          <span>Funkcia:&nbsp;</span>Spoločnosť Google používa súbory cookie na zhromažďovanie webových štatistík a
          sledovanie miery konverzie.
        </li>
        <li>
          <span>Platnosť: 2 roky</span>
        </li>
      </ul>
      <b>
        Google Tag Manager
        <br />
      </b>
      <ul>
        <li>
          <span>Typ súboru: </span>
          <span>Trvalé</span>
        </li>
        <li>
          <span>Účel: </span>
          <span>Analýza/meranie</span>
        </li>
        <li>
          <span>Funkcia:&nbsp;</span>Spoločnosť Google používa súbory cookie na zhromažďovanie webových štatistík a
          sledovanie miery konverzie.
        </li>
        <li>
          <span>Platnosť: 1-20 rokov</span>
        </li>
      </ul>
      <b>
        Netquest
        <br />
      </b>
      <ul>
        <li>
          <span>Typ súboru: </span>
          <span>Trvalé</span>
        </li>
        <li>
          <span>Účel: </span>
          <span>Analýza/meranie</span>
        </li>
        <li>
          <span>Funkcia:&nbsp;</span>Spoločnosť Netquest používa súbory cookie na získavanie webových štatistík na
          analýzu spätnej väzby a spracovanie prieskumov.
        </li>
      </ul>
      <h2>Reklamné cookies</h2>
      <p>
        Nasledujúca tabuľka uvádza cookies, ktoré používame na marketingové účely. Aj tieto súbory cookie nastavuje
        tretia strana a nie my. Súhlas s&nbsp; ich použitím môžete kedykoľvek zrušiť nastavením svojho prehliadača, ako
        je uvedené ďalej. Blokovanie týchto súborov neovplyvní fungovanie služby Dramox.&nbsp;
      </p>
      <b>
        Google Ads
        <br />
      </b>
      <ul>
        <li>Typ súboru: Trvalé</li>
        <li>Účel: Zobrazenie / cielenie reklamy</li>
        <li>
          Funkcia: Webová stránka používa tieto súbory cookie na meranie účinnosti svojich online marketingových kampaní
        </li>
        <li>Platnosť: 1 rok</li>
      </ul>
      <b>
        Facebook
        <br />
      </b>
      <ul>
        <li>Typ súboru: Trvalé</li>
        <li>Účel: Zobrazenie / cielenie reklamy</li>
        <li>
          Funkcia: Webová stránka používa tieto súbory cookie na meranie účinnosti svojich online marketingových kampaní
        </li>
        <li>Platnosť: 1 rok</li>
      </ul>
      <b>
        Sklik
        <br />
      </b>
      <ul>
        <li>Typ súboru: Trvalé</li>
        <li>Účel: Zobrazenie / cielenie reklamy</li>
        <li>
          Funkcia: Webová stránka používa tieto súbory cookie na meranie účinnosti svojich online marketingových kampaní
        </li>
        <li>Platnosť: 1 rok</li>
      </ul>
      <b>
        Google Remarketing
        <br />
      </b>
      <ul>
        <li>Typ súboru: Trvalé</li>
        <li>Účel: Zobrazenie / cielenie reklamy</li>
        <li>
          Funkce: Webová stránka používa tieto súbory cookie na meranie účinnosti svojich online marketingových kampaní
        </li>
        <li>Platnosť: 1 rok</li>
      </ul>
    </>
  );
}

function enCookie() {
  return (
    <>
      <h2>Website Cookies (Strictly Necessary Cookies)</h2>
      <p>
        Some cookies we use are necessary for the provision of Dramox services. If you disable these cookies in your
        browser settings, you will not be able to use our website and services. The following table lists the cookies we
        use and the reasons for using them. Please note that the cookies described in this policy are used on all
        platforms where our services are available.
      </p>
      <b>Functional cookies</b>
      <ul>
        <li>File type: Permanent</li>
        <li>Purpose: website functionality</li>
        <li>
          Function: They help to identify your computer if you revisit our website. They allow us to tailor our website
          to your needs.
        </li>
        <li>Validity: 1 year</li>
      </ul>
      <h2>Third-Party Cookies (Analytical Cookies)</h2>
      <p>
        The cookies listed below are placed by third parties, not by our website. These cookies may only be used with
        your prior consent.
      </p>
      <b>
        Hotjar
        <br />
      </b>
      <ul>
        <li>File type: Permanent</li>
        <li>Purpose: Analysis/measurement</li>
        <li>
          Function:&nbsp;Hotjar uses certain cookies to identify visitors, evaluate visitor behaviour patterns, and
          analyse traffic.
        </li>
        <li>Validity: 1 year</li>
      </ul>
      <b>
        <b>
          <b>
            Google&nbsp;Analytics
            <br />
          </b>
        </b>
      </b>
      <ul>
        <li>
          <span>
            File type:<span>&nbsp;</span>
          </span>
          <span>Permanent</span>
        </li>
        <li>
          <span>
            Purpose:<span>&nbsp;</span>
          </span>
          <span>Analysis/measurement</span>
        </li>
        <li>
          <span>Function:&nbsp;</span>Google uses cookies to obtain web statistics and track conversion rates.
        </li>
        <li>
          <span>Validity: 2 years</span>
        </li>
      </ul>
      <b>
        Google Tag Manager
        <br />
      </b>
      <ul>
        <li>
          <span>File type:</span>
          <span>Permanent</span>
        </li>
        <li>
          <span>Purpose: </span>
          <span>Analysis/measurement</span>
        </li>
        <li>
          <span>Function:&nbsp;</span>Google uses cookies to obtain web statistics and track conversion rates.
        </li>
        <li>
          <span>Validity: 1-20 years</span>
        </li>
      </ul>
      <b>
        Netquest
        <br />
      </b>
      <ul>
        <li>
          <span>File type: </span>
          <span>Permanent</span>
        </li>
        <li>
          <span>Purpose: </span>
          <span>Analysis/measurement</span>
        </li>
        <li>
          <span>Function:&nbsp;</span>Netquest uses cookies to obtain web statistics to analyse feedback and process
          surveys.
        </li>
      </ul>
      <h2>Marketing Cookies</h2>
      <p>
        The following table lists the cookies we use for marketing purposes. These cookies are also placed by a third
        party and not by us. At any time, you can withdraw your consent in the settings of your browser, as specified
        below. Blocking these files will not affect the functioning of Dramox services.&nbsp;
      </p>
      <b>
        Google Ads
        <br />
      </b>
      <ul>
        <li>File type: Permanent</li>
        <li>Purpose: Display / ad targeting</li>
        <li>Function: The website uses these cookies to measure the effectiveness of its online marketing campaigns</li>
        <li>Validity: 1 year</li>
      </ul>
      <b>
        Facebook
        <br />
      </b>
      <ul>
        <li>File type: Permanent</li>
        <li>Purpose: Display / ad targeting</li>
        <li>Function: The website uses these cookies to measure the effectiveness of its online marketing campaigns</li>
        <li>Validity: 1 year</li>
      </ul>
      <b>
        Sklik
        <br />
      </b>
      <ul>
        <li>File type: Permanent</li>
        <li>Purpose: Display / ad targeting</li>
        <li>Function: The website uses these cookies to measure the effectiveness of its online marketing campaigns</li>
        <li>Validity: 1 year</li>
      </ul>
      <b>
        Google Remarketing
        <br />
      </b>
      <ul>
        <li>File type: Permanent</li>
        <li>Purpose: Display / ad targeting</li>
        <li>Function: The website uses these cookies to measure the effectiveness of its online marketing campaigns</li>
        <li>Validity: 1 year</li>
      </ul>
    </>
  );
}

function ukCookie() {
  return (
    <>
      <h2>Файли cookie веб-сайту (обов’язкові файли cookie)</h2>
      <p>
        Деякі файли cookie, які ми використовуємо, необхідні для надання послуг Dramox. Якщо ви вимкнете такі файли
        cookie в налаштуваннях свого браузера, ви не зможете користуватися нашим веб-сайтом і послугами. У наступній
        таблиці наведено файли cookie веб-сайтів, які ми використовуємо, і причини їхнього використання. Зверніть увагу,
        що файли cookie, описані в цій політиці, використовуються на всіх платформах, на яких доступні наші послуги.
      </p>
      <b>Функціональні файли cookie</b>
      <ul>
        <li>Тип файлу: Постійний</li>
        <li>Мета: функціональність сайту</li>
        <li>
          Функція: Вони допомагають ідентифікувати ваш комп’ютер, якщо ви знову відвідаєте наш веб-сайт. Вони дозволяють
          нам адаптувати наш веб-сайт відповідно до ваших потреб. 1 рік
        </li>
        <li>Термін дії: 1 рікr</li>
      </ul>
      <h2>Файли cookie третіх сторін (аналітичні файли cookie)</h2>
      <p>
        Наведені нижче файли cookie налаштовуються третіми сторонами, а не нашим сайтом. Ці файли cookie можна
        використовувати лише з вашої попередньої згоди.
      </p>
      <b>
        Hotjar
        <br />
      </b>
      <ul>
        <li>Тип файлу: Постійний</li>
        <li>Мета: Аналіз/вимірювання</li>
        <li>
          Функція:&nbsp;Hotjar використовує певні файли cookie для ідентифікації відвідувачів, оцінки моделей поведінки
          відвідувачів та аналізу трафіку.
        </li>
        <li>Термін дії: 1 рікr</li>
      </ul>
      <b>
        <b>
          <b>
            Google&nbsp;Analytics
            <br />
          </b>
        </b>
      </b>
      <ul>
        <li>
          <span>
            Тип файлу:<span>&nbsp;</span>
          </span>
          <span>Постійний</span>
        </li>
        <li>
          <span>
            Мета:<span>&nbsp;</span>
          </span>
          <span>Аналіз/вимірювання</span>
        </li>
        <li>
          <span>Функція:&nbsp;</span>Google використовує файли cookie для отримання веб-статистики та відстеження
          коефіцієнтів конверсії.
        </li>
        <li>
          <span>Термін дії: 2 роки</span>
        </li>
      </ul>
      <b>
        Google Tag Manager
        <br />
      </b>
      <ul>
        <li>
          <span>Тип файлу:</span>
          <span>Постійний</span>
        </li>
        <li>
          <span>Мета: </span>
          <span>Аналіз/вимірювання</span>
        </li>
        <li>
          <span>Функція:&nbsp;</span>Google використовує файли cookie для отримання веб-статистики та відстеження
          коефіцієнтів конверсії.
        </li>
        <li>
          <span>Термін дії: 1-20 років</span>
        </li>
      </ul>
      <b>
        Netquest
        <br />
      </b>
      <ul>
        <li>
          <span>Тип файлу: </span>
          <span>Постійний</span>
        </li>
        <li>
          <span>Мета: </span>
          <span>Аналіз/вимірювання</span>
        </li>
        <li>
          <span>Функція:&nbsp;</span>Netquest використовує файли cookie для отримання веб-статистики, аналізу зворотного
          зв’язку та обробки опитувань.
        </li>
      </ul>
      <h2>Рекламні файли cookie</h2>
      <p>
        У наступній таблиці наведено файли cookie, які ми використовуємо для маркетингових цілей. Ці файли cookie також
        налаштовуються третьою стороною, а не нами. Ви можете відмовитися від їх використання в будь-який час,
        налаштувавши свій браузер, як описано нижче. Блокування цих файлів не вплине на роботу послуг Dramox.&nbsp;
      </p>
      <b>
        Google Ads
        <br />
      </b>
      <ul>
        <li>Тип файлу: Постійний</li>
        <li>Мета: Відображення / таргетування реклами</li>
        <li>
          Функція: Веб-сайт використовує ці файли cookie для вимірювання ефективності своїх маркетингових онлайн
          кампаній
        </li>
        <li>Термін дії: 1 рік</li>
      </ul>
      <b>
        Facebook
        <br />
      </b>
      <ul>
        <li>Тип файлу: Постійний</li>
        <li>Мета: Відображення / таргетування реклами</li>
        <li>
          Функція: Веб-сайт використовує ці файли cookie для вимірювання ефективності своїх маркетингових онлайн
          кампаній
        </li>
        <li>Термін дії: 1 рік</li>
      </ul>
      <b>
        Sklik
        <br />
      </b>
      <ul>
        <li>Тип файлу: Постійний</li>
        <li>Мета: Відображення / таргетування реклами</li>
        <li>
          Функція: Веб-сайт використовує ці файли cookie для вимірювання ефективності своїх маркетингових онлайн
          кампаній
        </li>
        <li>Термін дії: 1 рік</li>
      </ul>
      <b>
        Google Remarketing
        <br />
      </b>
      <ul>
        <li>Тип файлу: Постійний</li>
        <li>Мета: Відображення / таргетування реклами</li>
        <li>
          Функція: Веб-сайт використовує ці файли cookie для вимірювання ефективності своїх маркетингових онлайн
          кампаній
        </li>
        <li>Термін дії: 1 рік</li>
      </ul>
    </>
  );
}

function plCookie() {
  return (
    <>
      <h2>Niezbędne pliki cookies występujące na Portalu</h2>
      <p>
        Niektóre pliki cookies, których używamy, są niezbędne do świadczenia usług w ramach Portalu. Jeśli wyłączysz
        takie pliki cookies w ustawieniach swojej przeglądarki, nie będziesz mógł korzystać z Portalu i usług z nim
        związanych. Używane przez nas pliki cookies na stronach internetowych – w tym na Portalu - oraz powody ich
        używania są wymienione poniżej. Należy pamiętać, że pliki cookies opisane w Polityce są używane na wszystkich
        platformach, za pośrednictwem których dostępne są nasze usługi.
      </p>

      <strong>Funkcjonalne pliki cookies</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: zapewnienie odpowiedniej funkcjonalności strony internetowej</li>
        <li>
          Funkcja: Pomagają zidentyfikować Twój komputer, jeśli wrócisz na naszą stronę internetową (Portal). Pozwalają
          dostosować Portal do Twoich potrzeb.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>

      <strong>Zewnętrzne pliki cookies (analityczne)</strong>
      <p>
        Pliki cookies tego rodzaju są umieszczane przez osoby trzecie, a nie przez Portal. Te pliki cookies mogą być
        używane tylko za Twoją uprzednią zgodą.
      </p>
      <strong>Hotjar</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: Analiza/pomiar</li>
        <li>
          Funkcja: Hotjar wykorzystuje określone pliki cookies w celu identyfikacji odwiedzających, oceny wzorców
          zachowań i analizy ruchu użytkowników.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>
      <strong>Google Analytics</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: Analiza/pomiar</li>
        <li>
          Funkcja: Google używa plików cookies do zbierania statystyk online i śledzenia współczynników konwersji.
        </li>
        <li>Ważność: 2 lata</li>
      </ul>
      <strong>Google Tag Manager</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: Analiza/pomiar</li>
        <li>
          Funkcja: Google używa plików cookies do zbierania statystyk online i śledzenia współczynników konwersji.
        </li>
        <li>Ważność: 1-20 lat</li>
      </ul>

      <h2>Reklamowe pliki cookies</h2>
      <p>
        Te pliki cookies wykorzystywane są w celach marketingowych. Są one umieszczane przez osoby trzecie, a nie przez
        Portal. Możesz wyłączyć takie pliki cookies w dowolnym momencie w ustawieniach przeglądarki – zgodnie z
        poniższym opisem. Zablokowanie tych plików cookies nie wpłynie na działanie Portalu.
      </p>
      <strong>Google Ads</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: wyświetlanie reklam/targetowanie</li>
        <li>
          Funkcja: Witryny używają tych plików cookies do mierzenia skuteczności swoich kampanii marketingowych online.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>
      <strong>Facebook</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: wyświetlanie reklam/targetowanie</li>
        <li>
          Funkcja: Witryny używają tych plików cookies do mierzenia skuteczności swoich kampanii marketingowych online.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>
      <strong>Sklik</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: wyświetlanie reklam/targetowanie</li>
        <li>
          Funkcja: Witryny używają tych plików cookies do mierzenia skuteczności swoich kampanii marketingowych online.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>
      <strong>Google Remarketing</strong>
      <ul>
        <li>Typ pliku: Stały</li>
        <li>Cel: wyświetlanie reklam/targetowanie</li>
        <li>
          Funkcja: Witryny używają tych plików cookies do mierzenia skuteczności swoich kampanii marketingowych online.
        </li>
        <li>Ważność: 1 rok</li>
      </ul>
    </>
  );
}
